module.exports = __webpack_public_path__ + "static/creationCover-7453d3ad5b17e9128221a47ecb000167.jpg";